module.exports = __webpack_public_path__ + "img/userB27.eedaabac.jpg";